// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__maDGu","wrapper":"Icon_wrapper__ueUwR"};